import React from 'react';
import cx from 'classnames';

import iconAccessibility from '../utils/iconAccessibility';
import styles from './Icons.module.scss';

export interface Props {
  accessibilityLabel?: string;
  className?: Parameters<typeof cx>[0];
}

export const ProductIncome: React.FC<Props> = ({
  accessibilityLabel,
  className,
}) => (
  <i className={cx(styles.icon, className)}>
    <svg
      width={24}
      height={24}
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      {...iconAccessibility(accessibilityLabel)}
    >
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M12 5.65a2.75 2.75 0 100 5.5 2.75 2.75 0 000-5.5zM10.75 8.4a1.25 1.25 0 112.5 0 1.25 1.25 0 01-2.5 0z'
        fill='currentColor'
      />
      <path
        d='M5.25 5.35H8v1.5H6.75v3H8v1.5H5.25v-6zM16 6.85h1.25v3H16v1.5h2.75v-6H16v1.5z'
        fill='currentColor'
      />
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M21.75 3.05H2.25v17.9h19.5V3.05zm-18 9.1v-7.6h16.5v7.6H3.75zm0 3.7v-2.2h16.5v2.2H3.75zm0 1.5v2.1h16.5v-2.1H3.75z'
        fill='currentColor'
      />
    </svg>
  </i>
);

ProductIncome.displayName = 'ProductIncome';
export default ProductIncome;
